module.exports = __webpack_public_path__ + "img/circle-arrow-right.26f28b1c.svg";